import { defineStore } from 'pinia'
import type { Order } from '@/types/order'
import { getOrderInfo } from '@/api/order'
// import { get } from 'lodash-es'

// 替代 lodash.get
function get<T>(obj: any, path: string | string[], defaultValue?: T): T {
  const pathArr = Array.isArray(path) ? path : path.split('.').filter(Boolean);

  let result = obj;
  for (const key of pathArr) {
    if (result == null || !Object.prototype.hasOwnProperty.call(result, key)) {
      return defaultValue as T;
    }
    result = result[key];
  }

  // 明确处理 result 为 undefined 的情况
  return result !== undefined ? result : (defaultValue as T);
}

const storeKey = 'order'
export default defineStore(storeKey, {
  state: () => {
    return {
      info: {
        ordernumber: '',
        amount: '',
        is_expired: false,
        status: 0,
        product_code: '',
        extra_param: {
          qrcode: '',
          config: {
            qrcode_watermark: ''
          }
        },
      } as Order,
    }
  },
  getters: {
    expiredText(state) {
      return get(state.info, 'extra_param.chat_message.expire_message')
    },
    successText(state) {
      return get(state.info, 'extra_param.chat_message.payment_success_message')
    },
    jumpText(state) {
      return get(state.info, 'extra_param.chat_message.jump_message', '')
    },
  },
  actions: {
    getInfo() {
      return new Promise<Order>((resolve) => {
        getOrderInfo().then((res) => {
          if (res) {
            this.info = res
          }
          resolve(this.info)
        })
      })
    },
  },
})
